"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.error.cause.js");
require("core-js/modules/web.url-search-params.delete.js");
require("core-js/modules/web.url-search-params.has.js");
require("core-js/modules/web.url-search-params.size.js");
var _tslib = require("tslib");
var _vuePropertyDecorator = require("vue-property-decorator");
let QuotePreview = class QuotePreview extends _vuePropertyDecorator.Vue {
  constructor() {
    super(...arguments);
    this.blobUrl = '';
    this.rawUrl = '';
    this.error = '';
  }
  async created() {
    const file = this.$route.query.file;
    if (!file || file === 'true') {
      this.error = 'Invalid PDF file URL.';
      return;
    }
    this.rawUrl = Array.isArray(file) ? file[0] : file;
    try {
      const response = await fetch(this.rawUrl);
      if (!response.ok) throw new Error(`HTTP ${response.status}`);
      const blob = await response.blob();
      const pdfBlob = new Blob([blob], {
        type: 'application/pdf'
      });
      this.blobUrl = URL.createObjectURL(pdfBlob);
    } catch (e) {
      this.error = 'Could not load PDF preview.';
    }
  }
  beforeDestroy() {
    if (this.blobUrl) URL.revokeObjectURL(this.blobUrl);
  }
};
QuotePreview = (0, _tslib.__decorate)([_vuePropertyDecorator.Component], QuotePreview);
var _default = exports.default = QuotePreview;